import ApiClient from './ApiClient';

class IframeCreator extends ApiClient {
  constructor() {
    super('iframe_creators', { accountScoped: true });
  }
}

export default new IframeCreator();
